export default __webpack_public_path__ + "static/media/loader.2ef45767.svg";